<template>
  <div class="box-change-password clearfix">
    <div class="box-title">{{ labels['60'] }}</div>

    <label v-if="flgAction!=='login'" class="box-input-material position-up clearfix">
      <div class="glyphicon glyphicon-user icon-id"></div>
      <input  class="upper" :class="{ 'focus' : username != '', 'input-error' : errors.has('username') }"
              v-model="username"
              @keyup.enter=" flgAction === 'forgot' ? $refs.newPasswordInput.focus() : $refs.passwordInput.focus()"
              @keyup="clearResponse()"
              name="username"
              v-validate="'required'">
      <span>{{ labels['20'] }}</span>
      <div class="login-validate" v-show="errors.has('username')">{{ errors.first('username') }}</div>
    </label>

    <label v-if="flgAction==='change'" class="box-input-material clearfix">
      <div class="fa fa-key icon-id"></div>
      <input  :class="{ 'focus' : password != '', 'input-error' : errors.has('password') }"
              type="password"
              v-model="password"
              ref="passwordInput"
              @keyup.enter="$refs.newPasswordInput.focus()"
              @keyup="clearResponse()"
              name="password"
              v-validate="'required'">
      <span>{{ labels['80'] }}</span>
      <div class="login-validate" v-show="errors.has('password')">{{ errors.first('password') }}</div>
    </label>

    <label class="input-password box-input-material clearfix">
      <div class="fa fa-key icon-id"></div>
      <input  :class="{ 'focus' : newPassword != '', 'input-error' : errors.has('newPassword') }"
              type="password"
              v-model="newPassword"
              ref="newPasswordInput"
              @keyup.enter="$refs.confirmNewPasswordInput.focus()"
              @keyup="clearResponse()"
              name="newPassword"
              v-validate="'required'">
      <span>{{ labels['90'] }}</span>
      <div class="login-validate" v-show="errors.has('newPassword')">{{ errors.first('newPassword') }}</div>
    </label>

    <label class="input-password box-input-material clearfix">
      <div class="fa fa-key icon-id"></div>
      <input  :class="{ 'focus' : confirmNewPassword != '', 'input-error' : errors.has('confirmNewPassword') }"
              type="password"
              v-model="confirmNewPassword"
              ref="confirmNewPasswordInput"
              @keyup.enter="validateInput()"
              @keyup="clearResponse()"
              name="confirmNewPassword"
              v-validate="'required|confirmed:newPassword'">
      <span>{{ labels['100'] }}</span>
      <div class="login-validate" v-show="errors.has('confirmNewPassword')">{{ errors.first('confirmNewPassword') }}</div>
    </label>

    <div class="infinite-loading-container" v-if="loadingDisp"><i class="loading-wave-dots"></i></div>
    <div class="response-msg" :class="getStatusResponse" v-show="changePasswordResponse !== ''">
      <div>{{ changePasswordResponse }}</div>
      <div v-for="(msgFormat, index) in formatPassword" :key="index" class="format-password" >
        {{msgFormat.message_alert}}
      </div>
    </div>
    <button class="btn-change submit" v-on:click="validateInput()" v-show="!dispBtnOk">{{ labels['120'] }}</button>
    <button class="btn-change cancel" v-on:click="cancel()" v-show="!dispBtnOk">{{ labels['110'] }}</button>
    <button class="btn-change submit" v-on:click="cancel()" v-show="dispBtnOk">{{ labels['130'] }}</button>
  </div>
</template>

<script>
import { EncodeUtils } from 'assets/encode'

export default {
  name: 'change-password',
  data () {
    return {
      username: '',
      password: '',
      newPassword: '',
      confirmNewPassword: '',
      errorConfirmNewPassword: '',
      responseMsg: '',
      isLoading: false,
      dispBtnOk: false
    }
  },
  props: [
    'pcDisp',
    'goLogin',
    'postChangePassword',
    'changePasswordResponse',
    'setChangePasswordResponse',
    'inputUsername',
    'flgAction',
    'formatPassword',
    'setMsgFormatPassword',
    'labels'
  ],
  watch: {
    inputUsername () {
      this.username = this.inputUsername
    }
  },
  methods: {
    clearResponse () {
      this.isLoading = false
      this.setChangePasswordResponse('')
    },
    validateInput () {
      this.isLoading = false
      this.setChangePasswordResponse('')
      this.$validator.validateAll().then(result => {
        if (result) {
          this.isLoading = true
          var formChangePassword = {
            flgAction: this.flgAction,
            chg_username: this.username,
            chg_password: EncodeUtils.stdenc(this.password),
            chg_new_password: EncodeUtils.stdenc(this.newPassword)
          }
          this.postChangePassword(formChangePassword)
        }
      })
    },
    cancel () {
      this.username = this.inputUsername
      this.password = ''
      this.newPassword = ''
      this.confirmNewPassword = ''
      this.errorConfirmNewPassword = ''
      this.clearResponse()
      this.errors.clear()
      this.goLogin()
      this.setMsgFormatPassword([])
    }
  },
  computed: {
    loadingDisp () {
      return this.isLoading && (this.changePasswordResponse === '')
    },
    getStatusResponse () {
      let result
      if (this.changePasswordResponse.search('HR2410') !== -1) {
        this.isLoading = false
        this.dispBtnOk = true
        result = 'msg-success'
      } else {
        this.dispBtnOk = false
        result = ''
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// changePassword.vue?df5011ee